import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import SafeIcon from '../common/SafeIcon';
import './forms.css';

function localDateString(date) {
  const offset = date.getTimezoneOffset();
  return new Date(date.getTime() - offset * 60_000).toISOString().slice(0, 10);
}

export default function AvailabilityForm() {
  const navigate = useNavigate();
  const today = localDateString(new Date());
  const [checkIn, setCheckIn] = useState('');
  const [checkOut, setCheckOut] = useState('');
  const [guests, setGuests] = useState('1');
  const [error, setError] = useState('');

  function submitAvailability(event) {
    event.preventDefault();
    if (checkOut <= checkIn) {
      setError('Check-out must be later than check-in.');
      return;
    }

    const params = new URLSearchParams({ checkIn, checkOut, guests });
    navigate(`/booking?${params.toString()}`);
  }

  return (
    <form className="availability-form" onSubmit={submitAvailability}>
      <label className="form-field">
        <span>Check-in</span>
        <input
          type="date"
          value={checkIn}
          min={today}
          required
          onChange={(event) => {
            setCheckIn(event.target.value);
            setError('');
          }}
        />
      </label>
      <label className="form-field">
        <span>Check-out</span>
        <input
          type="date"
          value={checkOut}
          min={checkIn || today}
          required
          onChange={(event) => {
            setCheckOut(event.target.value);
            setError('');
          }}
        />
      </label>
      <label className="form-field">
        <span>Guests</span>
        <input
          type="number"
          min="1"
          step="1"
          value={guests}
          required
          onChange={(event) => setGuests(event.target.value)}
        />
      </label>
      <button className="button button-gold availability-submit" type="submit">
        Check Availability <SafeIcon name="ArrowRight" />
      </button>
      <p className="form-note" role="status">
        {error || 'Your dates will be carried into a booking enquiry.'}
      </p>
    </form>
  );
}